import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { IconButton, ShareIcon, Typography } from "@parkschannel/ui";
import Link from "next/link";
import { useResolveUserPublicProfilePagePath } from "../../Pages/UserPublicProfilePage/path";
import { TruncatedTagsList } from "../../Tags";
import { Share } from "../../Share/Share";
import { NextAvatar } from "../../NextAvatar";
export const AuthorCard = (param)=>{
    let { data , className  } = param;
    return /*#__PURE__*/ _jsx(Link, {
        href: useResolveUserPublicProfilePagePath(data.cognito_id),
        children: /*#__PURE__*/ _jsxs("article", {
            className: classNames("group relative p-4 bg-white rounded-2xl w-full min-w-[344px] h-[314px] hover:shadow-3xl group transition-all duration-200 cursor-pointer", className),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "bg-neutral-100 p-3 rounded-full w-fit",
                    children: /*#__PURE__*/ _jsx(NextAvatar, {
                        src: data.avatar_key,
                        size: "xl",
                        className: "drop-shadow-sm"
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    component: "h3",
                    variant: "h5",
                    className: classNames("mt-3 mb-1 text-neutral-900 line-clamp-1 md:text-xl"),
                    children: data.name
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "bodyLarge",
                    className: classNames("text-neutral-600 !text-xs mb-3 line-clamp-5 h-[80px]"),
                    children: data.description
                }),
                /*#__PURE__*/ _jsxs(Typography, {
                    variant: "bodyLarge",
                    className: "!text-xs text-neutral-700 font-medium flex items-center gap-1 mb-1",
                    children: [
                        data.subscriptionsCount,
                        " subscribers"
                    ]
                }),
                /*#__PURE__*/ _jsx(TruncatedTagsList, {
                    tags: data.tags
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "absolute top-2 right-2 lg:opacity-0 lg:group-hover:opacity-100 transition duration-200",
                    onClick: (e)=>e.preventDefault(),
                    children: /*#__PURE__*/ _jsx(Share, {
                        data: {
                            title: data.name,
                            url: useResolveUserPublicProfilePagePath(data.cognito_id)
                        },
                        children: /*#__PURE__*/ _jsx(IconButton, {
                            icon: /*#__PURE__*/ _jsx(ShareIcon, {
                                className: "w-6 h-6"
                            }),
                            variant: "text"
                        })
                    })
                })
            ]
        })
    });
};
